import { render, staticRenderFns } from "./JBProposalInsureds.vue?vue&type=template&id=4c5a2414"
import script from "./JBProposalInsureds.vue?vue&type=script&lang=js"
export * from "./JBProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports